import axios from 'axios'
import Cookies from 'js-cookie'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { getBaseUrl } from "../../service/apiUrl";
export const userLogin = createAsyncThunk(
  'user/login',
  async ({ Email, password }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      }
      const { data } = await axios.post(
        `${getBaseUrl()}/login`,
        { Email, password },
        config
      )
      Cookies.set('token', data.token)
      Cookies.set('id', data.user._id)
      
      return data
    } catch (error) {
              Cookies.set("token",error.response.data.token)

      if (error.response && error.response.data.message) {
 
        return rejectWithValue(error.response)
      } else {
        Cookies.set("token",error.response.data.token)
        return rejectWithValue(error)
      }
    }
  }
)

export const registerUser = createAsyncThunk(
  'user/register',
  async ({ FirstName,LastName,PassportNo,PhoneNumber,password,Email }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      }

      const { data } = await axios.post(
        `${getBaseUrl()}/register`,
        { FirstName,LastName,PassportNo,PhoneNumber,password,Email },
        config
      )
      Cookies.set('token', data.token)
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)

export const getUserDetails = createAsyncThunk(
  'user/getUserDetails',
  async (arg, { getState, rejectWithValue }) => {
    try {
      // get user data from store
      const { user } = getState()
      
      // configure authorization header with user's token
      const config = {
        headers: {
          Authorization: user.token,
        },
      }

      const { data } = await axios.get(`${getBaseUrl()}/singlesubscriber/${Cookies.get('id')}`, config)
      return data
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message)
      } else {
        return rejectWithValue(error.message)
      }
    }
  }
)